var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUspBadgeEuro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide/badge-euro"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.70924 5.80026C2.61439 5.37287 2.62896 4.92843 2.75158 4.50817C2.87419 4.08791 3.1009 3.70542 3.41067 3.39617C3.72045 3.08693 4.10326 2.86093 4.52361 2.73914C4.94397 2.61736 5.38825 2.60372 5.81528 2.69949C6.05032 2.33176 6.37411 2.02913 6.75681 1.8195C7.13951 1.60988 7.5688 1.5 8.00511 1.5C8.44142 1.5 8.87071 1.60988 9.25341 1.8195C9.6361 2.02913 9.9599 2.33176 10.1949 2.69949C10.6226 2.6033 11.0677 2.61688 11.4887 2.73896C11.9097 2.86104 12.293 3.08767 12.603 3.39775C12.913 3.70784 13.1395 4.09131 13.2615 4.5125C13.3836 4.93369 13.3971 5.37892 13.301 5.80676C13.6686 6.04189 13.9711 6.36581 14.1806 6.74866C14.3902 7.13151 14.5 7.56097 14.5 7.99745C14.5 8.43393 14.3902 8.86339 14.1806 9.24624C13.9711 9.62909 13.6686 9.95301 13.301 10.1881C13.3967 10.6153 13.3831 11.0598 13.2613 11.4803C13.1396 11.9008 12.9137 12.2838 12.6046 12.5937C12.2954 12.9036 11.9131 13.1304 11.493 13.2531C11.0729 13.3757 10.6287 13.3903 10.2014 13.2954C9.9667 13.6646 9.64265 13.9685 9.2593 14.179C8.87595 14.3896 8.44569 14.5 8.00836 14.5C7.57102 14.5 7.14076 14.3896 6.75741 14.179C6.37406 13.9685 6.05001 13.6646 5.81528 13.2954C5.38825 13.3912 4.94397 13.3775 4.52361 13.2558C4.10326 13.134 3.72045 12.908 3.41067 12.5987C3.1009 12.2895 2.87419 11.907 2.75158 11.4867C2.62896 11.0665 2.61439 10.622 2.70924 10.1946C2.33882 9.96013 2.03371 9.63571 1.82229 9.25155C1.61087 8.86739 1.5 8.43598 1.5 7.99745C1.5 7.55892 1.61087 7.12751 1.82229 6.74335C2.03371 6.3592 2.33882 6.03477 2.70924 5.80026Z",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5 8H8",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5 6.05C10.1225 5.58398 9.61886 5.25131 9.05685 5.09679C8.49485 4.94228 7.9015 4.97334 7.35672 5.1858C6.81195 5.39827 6.34192 5.78192 6.00995 6.28508C5.67797 6.78825 5.5 7.38676 5.5 8C5.5 8.61324 5.67797 9.21175 6.00995 9.71492C6.34192 10.2181 6.81195 10.6017 7.35672 10.8142C7.9015 11.0267 8.49485 11.0577 9.05685 10.9032C9.61886 10.7487 10.1225 10.416 10.5 9.95",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUspBadgeEuro);
export default __webpack_public_path__ + "static/media/usp-badge-euro.fd06ad7d6c669c1418357ea149f512bc.svg";
export { ForwardRef as ReactComponent };